<template>
  <div>
    <div v-if="carregando == true" class="carregando">
      <img width="130px" :src="iconeCarregando" />
      <br />
      <br />Carregando...
    </div>
    <VCreditCard :trans="translations" @change="creditInfoChanged" />

    <!--vs-button
      class="w-full"
      :disabled="carregando"
      block
      type="gradient"
      icon-pack="feather"
      icon="icon-check"
      icon-before
      size="large"
      color="success"
      @click="adicionar"
    >
      <span>{{ textoBotao ? textoBotao : 'Adicionar Cartão' }}</span>
    </vs-button-->
    <div class="text-center">
      <n-button
        :disabled="carregando"
        @click="adicionar"
        class="     btn-degrade "
        type="success"
        >{{
          carregando
            ? 'Carregando...'
            : textoBotao
            ? textoBotao
            : 'Adicionar Cartão'
        }}</n-button
      >
    </div>
  </div>
</template>
<!-- eslint-disable -->
<script>
import VCreditCard from 'v-credit-card';
import 'v-credit-card/dist/VCreditCard.css';
import service from './../../services';
import { Button } from '@/components';
const translations = {
  name: {
    label: 'Nome',
    placeholder: 'Nome completo',
  },
  card: {
    label: 'Número do Cartão',
    placeholder: 'Número do Cartão',
  },
  expiration: {
    label: 'Expiração',
  },
  security: {
    label: 'Código de segurança',
    placeholder: 'Código',
  },
};

export default {
  data() {
    return {
      iconeCarregando: service.getEnvIconeCarregando(),
      carregando: false,
      translations,
      name: '',
      cardNumber: '',
      expiration: '',
      security: '',
    };
  },
  props: ['idUsuario', 'typeCard', 'textoBotao'],
  methods: {
    creditInfoChanged(values) {
      for (const key in values) {
        this[key] = values[key];
      }
    },
    adicionarCartao(obj) {
      this.carregando = true;
      service
        .post('Usuario', 'AdicionarCartao', {
          ...obj,
          idUsuario: this.idUsuario,
        })
        .then(res => {
          this.carregando = false;
          this.$emit('adicionar', {
            name: this.name,
            cardNumber: res.data.number,
            expiration: this.expiration,
            security: this.security,
            bandeira: res.data.Brand.name,
            selecionado: true,
            idCartao: res.data.myId,
          });
        })
        .catch(e => {
          console.log(e);
          swal('ops!', e, 'error');
          this.carregando = false;
        });
    },
    adicionar() {
      var msg = [];
      if (this.name == '') {
        msg.push('Preencha o Nome Completo');
      }

      if (this.cardNumber == '') {
        msg.push('Preencha o número do Cartão');
      } else {
        if (this.cardNumber.length != 19) {
          msg.push('Preencha o número do Cartão Completo');
        }
      }

      if (this.expiration == '') {
        msg.push('Preencha o vencimento do Cartão');
      } else {
        if (this.expiration.length != 5) {
          msg.push('Preencha o vencimento do Cartão MM/YY');
        }
      }

      if (this.security == '') {
        msg.push('Preencha o código de segurança do Cartão');
      } else {
        if (this.security < 3) {
          msg.push('Preencha o código de segurança do Cartão corretamente');
        }
      }

      if (msg.length > 0) {
        swal('ops!', msg.toString().replace(/,/g, '\n'), 'error');
        /*this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: msg.toString(),
          color: 'danger',
        });*/
        return;
      } else {
        this.adicionarCartao({
          name: this.name,
          cardNumber: this.cardNumber,
          expiration: this.expiration,
          security: this.security,
          selecionado: true,
        });
        /*this.$emit("adicionar", {
          name: this.name,
          cardNumber: this.cardNumber,
          expiration: this.expiration,
          security: this.security,
          selecionado: true,
        });*/
      }
    },
  },
  components: {
    VCreditCard,
    [Button.name]: Button,
  },
};
</script>
<style>
.vue-credit-card .card-form-and-image .credit-card-form {
  padding: 0px !important;
  color: #fff !important;
}
.vue-credit-card .ccicon {
  top: 50%;
}
</style>
